import {
  RTL_LAYOUT,
  SET_LANGUAGE,
  SET_PRECISION,
  SITEVALIDATION,
} from "Stores/actionTypes";
import { updateObject } from "./utility";
import AppConfig from "../../Constants/AppConfig";

const INIT_STATE = {
  rtlLayout: AppConfig.rtlLayout,
  cwt: null,
  locale: AppConfig.locale,
  precision: 0,
  languages: [
    {
      languageId: "english",
      locale: "en",
      name: "English",
      icon: "en",
    },
    {
      languageId: "persian",
      locale: "fa",
      name: "فارسی",
      icon: "fa",
    },
  ],
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    // rtl layout
    case RTL_LAYOUT:
      return updateObject(state, { rtlLayout: action.rtlLayout });
    // set language
    case SET_LANGUAGE:
      return updateObject(state, { locale: action.locale });
    // set precision
    case SET_PRECISION:
      return updateObject(state, { precision: action.precision });
    case SITEVALIDATION:
      return updateObject(state, { cwt: action.cwt });
    default:
      return { ...state };
  }
};
